import {app} from "./firebase"
import {getDatabase, ref} from "firebase/database"

const db = getDatabase(app)

const messagesRef = (userId, roomId) => ref(db, `Chat/${userId}/${roomId}`)
const chatStateRef = (userId, roomId) =>
    ref(db, `ChatState/${userId}/${roomId}`)
const chatStateVoiceStatusRef = (userId, roomId) =>
    ref(db, `ChatState/${userId}/${roomId}/${ChatStateFields.VOICE_STATUS}`)
const chatStateModelLoadingStatusRef = (userId, roomId) =>
    ref(db, `ChatState/${userId}/${roomId}/${ChatStateFields.MODEL_LOADING_STATUS}`)
const chatStateModelLoadingProgressRef = (userId, roomId) =>
    ref(db, `ChatState/${userId}/${roomId}/${ChatStateFields.MODEL_LOADING_PROGRESS}`)

export const ChatStateFields = {
    VOICE_STATUS: "voiceStatus",
    MODEL_LOADING_STATUS: "loadStatus",
    MODEL_LOADING_PROGRESS: "loadProgress",
}

export const dbRefs = {
    messagesRef,
    chatStateRef,
    chatStateVoiceStatusRef,
    chatStateModelLoadingStatusRef,
    chatStateModelLoadingProgressRef,
}
